module.exports = __webpack_public_path__ + "img/1501698808.678014a2.jpg";